import * as yup from 'yup';
import { VALIDATION } from 'Helpers/validations';

export const schema = yup.object().shape({
	userEmail: VALIDATION.email.label('user.email').required()
});
